<div class="card" (click)="onCardClick()" [class.pointer]="button()">
  <div class="card-content">
    @if ((loading$ | async) === false) {
      <div class="icon">
        <ng-content select="[slot=icon]" />
      </div>
    } @else {
      <div class="icon">
        <lyceo-skeleton-text />
      </div>
    }
    <div class="item">
      <div class="label">
        @if ((loading$ | async) === false) {
          @if (titlePlacement() === 'top' && title()) {
            <p>{{ title() }}</p>
          }
          <h3 [class.center]="!statisticName() || !statisticNamePlural()">
            {{ statisticPrefix() }}
            {{ value$ | async | number: digitsInfo() }}
            @if (statisticName() && statisticNamePlural()) {
              {{
                (value$ | async) === 1 ? statisticName() : statisticNamePlural()
              }}
            }
          </h3>
          @if (titlePlacement() === 'bottom' && title()) {
            <p class="paragraph-medium">
              {{ title() }}
            </p>
          }
        } @else {
          @if (titlePlacement() === 'top' && title()) {
            <p>
              <lyceo-skeleton-text style="width: 20ch; height: 12px" />
            </p>
          }
          <h3
            class="loading"
            [class.center]="!statisticName() || !statisticNamePlural()"
          >
            <lyceo-skeleton-text style="width: 4ch; height: 24px" />
          </h3>
          @if (titlePlacement() === 'bottom' && title()) {
            <p class="paragraph-medium">
              <lyceo-skeleton-text style="width: 20ch; height: 12px" />
            </p>
          }
        }
      </div>

      @if (previousValue() !== undefined) {
        @if ((loading$ | async) === false) {
          @if (differenceWithPrevious$ | async; as difference) {
            <div slot="end" [class]="difference >= 0 ? 'positive' : 'negative'">
              <fa-icon
                [icon]="difference >= 0 ? faArrowTrendUp : faArrowTrendDown"
              />
              <span class="caption">
                @if (difference !== 0) {
                  {{ difference < 0 ? '-' : '+' }}
                }
                {{
                  (difference < 0
                    ? (difference.toString() | slice: 1)
                    : difference
                  ) | number: digitsInfo()
                }}
                @if (notation() === StatisticCardNotation.PERCENTAGE) {
                  %
                }
                >
              </span>
            </div>
          }
        } @else {
          <div slot="end">
            <lyceo-skeleton-text style="width: 36px; height: 36px" />
            <lyceo-skeleton-text style="width: 36px; height: 12px" />
          </div>
        }
      }
    </div>
  </div>
</div>
